import React from "react";
import { StaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import { useMediaQuery } from 'react-responsive';
import 'swiper/swiper-bundle.min.css';
import styled from "styled-components";
import Img from "gatsby-image";
import Comments from "../components/Comments";
import Breadscrum from "../components/Breadscrum";
import MapPin from "../assets/img/mapPin.svg";
import LinkButton from "../components/pohrby/LinkButton";
import Telefon from "../assets/img/telefon.svg";
import Features from "../components/pohrby/Features";
import RecenzePohreb from "../components/pohrby/RecenzePohreb";
import FAQ from "../components/FrequentlyAskedQ";
import Jo from "../assets/img/pricingCheck.svg";
import Next from "../assets/img/next.svg";
import Prev from "../assets/img/prev.svg";
import Block from "../components/Block";

const LokalitaInner = styled.section`
  background: #FBFBFA;

  .jumbotron {
    position: relative;
    padding: 100px 0;
    background: #f3f1eb;

    @media (max-width: 899px) {
      padding-top: 30px;
      padding-bottom: 45px;
    }

    .jumboInner {
      position: relative;
      z-index: 1;
      max-width: 1150px;
      margin: 0 auto;
      width: calc(100% - 100px);

      @media (max-width: 899px) {
        max-width: 600px;
        width: calc(100% - 50px);
      }

      .breadscrum {
        text-align: center;

        @media (max-width: 899px) {
          text-align: left;
        }
      }
      
      h1 {
        font-family: Ivar;
        font-size: 52px;
        color: #000000;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 40px;
        margin-top: 20px;
        ${props => props.isDark && "color: #fff;"}
        ${props => props.isDark && "text-shadow: 0 2px 30px rgba(0,0,0,0.23);"}

        @media (max-width: 899px) {
          text-align: left;
          font-size: 40px;
          line-height: 55px;
          margin-bottom: 25px;
        }

        @media (max-width: 500px) {
          font-size: 32px;
          line-height: 44px;
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 18px;
        color: #000000;
        text-align: center;
        line-height: 28px;
        margin: 0 auto;
        margin-bottom: 40px;
        max-width: 800px;
        ${props => props.isDark && "color: #fff;"}
        ${props => props.isDark && "text-shadow: 0 2px 30px rgba(0,0,0,0.23);"}


        @media (max-width: 899px) {
          text-align: left;
          font-size: 16px;
          line-height: 25px;
        }
      }

      .linkButton {
        a {
          margin: 0 auto;

          @media (max-width: 899px) {
            margin-left: 0;
          }
        }
      }

      .neboZavolejte {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        margin-top: 20px;

        @media (max-width: 899px) { 
          width: fit-content;
          margin-left: 0;
        }

        span {
          font-family: Visuelt-Regular;
          font-size: 16px;
          color: #000000;
          text-align: right;
          line-height: 28px;
          ${props => props.isDark && "color: #fff;"}
        }

        img {
          margin: 0 10px;
          margin-left: 12px;
          width: 18px;
          height: 18px;
        }

        a {
          margin: 0;
          font-family: Visuelt-Medium;
          font-size: 16px;
          color: #000000;
          text-align: center;
          line-height: 28px;
          text-decoration: underline;
          background: none;

          ${props => props.isDark && "color: #fff;"}
        }
      }
    }

    .pozadi {
      position: absolute !important;
      top: 0;
      z-index: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .uvod {
    max-width: 1150px;
    width: calc(100% - 100px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 120px;

    @media (max-width: 899px) {
      width: calc(100% - 50px);
      max-width: 600px;
      margin-top: 40px;
      display: block;
    }

    .left {
      width: calc(100% - 550px);

      @media (max-width: 1100px) {
        width: calc(100% - 400px);
      }

      @media (max-width: 899px) {
        width: calc(100%);
      }

      h2 {
        font-family: Ivar;
        font-size: 27px;
        color: #000000;
        line-height: 40px;
        margin-bottom: 30px;
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #5A5A5A;
        line-height: 25px;
      }
    }

    .right {
      iframe {
        width: 450px;
        height: 300px;

        @media (max-width: 1100px) {
          width: calc(350px);
        }

        @media (max-width: 899px) {
          width: calc(100%);
          margin-top: 40px;
        }
      }
    }
  }

  .zamestnanec {
    max-width: 1150px;
    width: calc(100% - 100px);
    margin: 120px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    @media (max-width: 899px) {
      width: calc(100% - 50px);
      max-width: 600px;
      display: block;
      margin: 60px auto;
    }

    .right {
      width: calc(100% - 550px);

      @media (max-width: 1100px) {
        width: calc(100% - 400px);
      }

      @media (max-width: 899px) {
        width: calc(100%);
      }

      h2 {
        font-family: Ivar;
        font-size: 27px;
        color: #000000;
        line-height: 40px;
        margin-bottom: 30px;
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #5A5A5A;
        line-height: 25px;
        margin-bottom: 35px;
      }
    }

    .left {
      @media (max-width: 1100px) {
        width: calc(350px);
      }

      @media (max-width: 899px) {
        width: 100%;
        margin-bottom: 40px;
      }

      .img {
        border-radius: 5px;
        
        @media (max-width: 1100px) {
          width: calc(100%) !important;
        }

        @media (max-width: 899px) {
          width: 450px !important;
        }

        @media (max-width: 500px) {
          width: calc(100%) !important;
          height: 350px !important;
        }

        @media (max-width: 400px) {
          height: 300px !important;
        }

        @media (max-width: 340px) {
          height: 280px !important;
        }
      }

      span {
        display: block;
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #000000;
        line-height: 25px;
        margin-top: 20px;
      }
    }
  }

  .sCimPomuzeme {
    background: #F3F1EC;
    padding-top: 60px;
    padding-bottom: 60px;

    .top {
      max-width: 1150px;
      width: calc(100% - 100px);
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 90px;

      @media (max-width: 899px) {
        margin-bottom: 40px;
      }

      @media (max-width: 899px) {
        display: block;
        width: calc(100% - 50px);
      }

      .left {
        width: calc(100% - 400px);

        @media (max-width: 899px) {
          width: calc(100%);
        }
      }

      .right {
        @media (max-width: 899px) {
          margin-top: 60px;
          display: none;
        }
      }

      h2 {
        font-family: Ivar;
        font-size: 27px;
        color: #000000;
        line-height: 40px;
        margin-bottom: 30px;
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #5A5A5A;
        line-height: 25px;
      }
    }

    .bot {
      .swiperContainer {

      }

      .swiper-container {
        width: 100%;
      }

      .swiper-pagination {
        @media (max-width: 500px) {
          margin-bottom: -12px;
        }

        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          margin: 0 6px;
        }

        .swiper-pagination-bullet-active {
          background: #1f4573;
        }
      }

      .naseSluzbyInner {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        max-width: 1150px;
        margin: 0 auto;
        width: calc(100% - 100px);

        @media (max-width: 1050px) {
          width: calc(100%);
        }

        .sluzbaBox {
          background: #FFFFFF;
          box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
          border-radius: 5px;
          width: calc((100% - 70px)/3);
          height: fit-content;
          overflow: hidden;

          @media (max-width: 1050px) {
            width: calc(100%);
            max-width: 300px;
          }

          @media (max-width: 600px) {
            max-width: none;
            width: calc(100vw - 80px);
            max-width: 300px;
          }

          .topImg {
            position: relative;
            width: 100%;
            height: 170px;

            .mainImg {
              position: absolute !important;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }

            .veSpolupraci {
              display: flex;
              align-items: baseline;
              justify-content: center;
              position: absolute;
              z-index: 2;
              background: rgba(255,255,255,0.9);
              border-radius: 3px;
              padding: 5px 10px;
              bottom: 20px;
              left: 20px;

              @media (max-width: 360px) {
                bottom: 10px;
                left: 10px;
                width: calc(100% - 40px);
                text-align: left;
              }

              p {
                font-family: Visuelt-Regular;
                font-size: 14px;
                color: #000000;
                text-align: left;
                line-height: 20px;
                margin: 0;

                a {
                  font-family: Visuelt-Regular;
                  font-size: 14px;
                  color: #000000;
                  text-align: center;
                  line-height: 24px;
                }
              }
            }
          }

          .bottom {
            width: calc(100% - 60px);
            margin: 0 auto;
            padding-bottom: 30px;

            @media (max-width: 600px) {
              width: calc(100% - 40px);
              padding-bottom: 20px;
            }
          }

          .h3Link {
            color: #000000;
            width: fit-content;
            display: block;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
              cursor: pointer;
            }

            @media (max-width: 900px) {

            }
          }

          h3 {
            font-family: Visuelt-Medium;
            font-size: 25px;
            color: #000000;
            margin-top: 30px;

            @media (max-width: 600px) {
              margin-top: 20px;
              font-size: 24px;
            }
          }

          p {
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #585858;
            line-height: 24px;
            margin-top: 15px;
            margin-bottom: 20px;
          }

          .cena {
            span {
              &:first-child {
                font-family: Visuelt-Medium;
                font-size: 16px;
                color: #212326;
              }

              &:last-child {
                font-family: Visuelt-Medium;
                font-size: 22px;
                color: #212326;
                margin-left: 7px;
              }
            }
          }

          .odrazky {
            border-top: 1px solid #D8D8D8;
            margin-top: 30px;
            padding-top: 30px;

            h4 {
              font-family: Visuelt-Medium;
              font-size: 20px;
              color: #000000;
            }

            ul {
              margin-bottom: 35px;

              li {
                list-style: none;
                display: flex;
                align-items: center;
                margin-top: 25px;

                span {
                  margin-left: 15px;
                  font-family: Visuelt-Regular;
                  font-size: 16px;
                  color: #000000;
                  line-height: 24px;
                }
              }
            }
          }

          .cta {
            font-family: Visuelt-Medium;
            font-size: 18px;
            color: #FFFFFF;
            text-align: center;
            margin: 0 auto;
            display: block;
            background: #1D3A5B;
            border-radius: 3px;
            padding: 19px 0;
            text-decoration: none;

            &:hover {
              background: #081C33;
              cursor: pointer;
            }
          }

          .zjistitVice {
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #919191;
            text-align: center;
            line-height: 24px;
            display: block;
            width: fit-content;
            margin: 0 auto;
            margin-top: 15px;

            &:hover {
              color: #565656;
            }
          }
        }
      }

      .naseSluzbyInnerSwiper {
        .swiper-slide {
          width: fit-content;
          margin-bottom: 80px;
          margin-top: 70px;

          @media (max-width: 1050px) {
            margin-bottom: 70px;
            margin-top: 0;
          }

          @media (max-width: 900px) {
            margin-bottom: 40px;
            margin-top: 30px;
          }

          @media (max-width: 600px) {
            width: fit-content;
            position: relative;
            max-width: 400px;
          }

          @media (max-width: 380px) {
            width: fit-content;
          }

          &:last-child {
            margin-right: 180px;

            @media (max-width: 600px) {
              margin-right: 50px;
              margin-right: 90px;
            }
          }
        }

        .swiper-slide-active {

        }


        .swiper-wrapper {
          left: 90px;

          @media (max-width: 600px) {
            left: 40px;
          }
        }

        .swiper-button-prev {
          left: 10px;
          background: url(${Prev});
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center right;
          height: 220px;
          top: 50%;
          transform: translateY(-50%);
          width: 70px;

          &::after {
            content: none;
          }

          @media (max-width: 400px) {
            top: 0;
            transform: inherit;
          }
        }

        .swiper-button-next {
          left: calc(100vw - 80px);
          background: url(${Next});
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center left;
          height: 220px;
          top: 50%;
          transform: translateY(-50%);
          width: 70px;

          &::after {
            content: none;
          }

          @media (max-width: 400px) {
            top: 0;
            transform: inherit;
          }
        }
      }
    }
  }
`;

const LokalitaTemplate = ({
  seoTitle,
  seoDesc,
  nazev,
  slug,
  jumboH1,
  jumboDesc,
  uvodH2,
  uvodDesc,
  uvodAdresa,
  zamestnanecH2,
  zamestnanecDesc,
  zamestnanecImg,
  zamestnanecUvod,
  sluzbyH2,
  sluzbyDesc,


  faqData,
}) => {

  const isLess1050 = useMediaQuery({
    query: '(max-width: 1050px)'
  });

  const isLess1000 = useMediaQuery({
    query: '(max-width: 1000px)'
  });

  const isPlus900 = useMediaQuery({
    query: '(max-width: 899px)'
  });

  const isPlus470 = useMediaQuery({
    query: '(min-width: 470px)'
  });

  return (
    <Layout>
      <SEO
        title={seoTitle}
        customTitle
        description={seoDesc}
      />

      <LokalitaInner isLess1000={isLess1000}>
        <StaticQuery
          query={graphql`
            query {
              pozadi: file(relativePath: { eq: "pohrebPozadi.jpg" }) {
                childImageSharp {
                  fluid(maxWidth: 1920) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }

              prochazka: file(relativePath: { eq: "ruce.png" }) {
                childImageSharp {
                  fixed(width: 320, quality: 100) {
                    ...GatsbyImageSharpFixed_noBase64
                  }
                }
              }
          
              prochazkaSmall: file(relativePath: { eq: "ruce.png" }) {
                childImageSharp {
                  fixed(width: 310, quality: 100) {
                    ...GatsbyImageSharpFixed_noBase64
                  }
                }
              }

              bezObradu: file(relativePath: { eq: "bezObradu.jpg" }) {
                childImageSharp {
                  fluid(maxWidth: 360) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          
              sObradem: file(relativePath: { eq: "rakev.jpg" }) {
                childImageSharp {
                  fluid(maxWidth: 360) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          
              netradicniPohreb: file(relativePath: { eq: "priroda.jpg" }) {
                childImageSharp {
                  fluid(maxWidth: 360) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
          `}
          render={data => ( <>

            <div className="jumbotron">
              <div className="jumboInner">
                <Breadscrum
                  visible={true}
                  stranky={[
                    {name: "Domů", url: "/"},
                    {name: "Pohřební služba", url: "/pohrebni-sluzba/"},
                    {name: "Kde fungujeme?", url: "/pobocky/"},
                    {name: nazev, url: `/${slug}/`},
                  ]}
                />

                <h1>{jumboH1}</h1>
                <p>{jumboDesc}</p>
                <LinkButton to="/nabidka/dotaznik/" text="Začít plánovat pohřeb" />
                <div className="neboZavolejte">
                  <span>Nebo zavolejte na</span>
                  <img src={Telefon} alt="Telefon" />
                  <a href="tel:315558136">315 558 136</a>
                </div>
              </div>

              <Img className="pozadi" alt="" fluid={data.pozadi.childImageSharp.fluid} />
            </div>

            <div className="uvod">
              <div className="left">
                <h2>{uvodH2}</h2>
                {uvodDesc}
              </div>
              <div className="right">
                <iframe
                  frameBorder="0"
                  title={nazev}
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDR-wPIwbrQ2srKQ5FYSRXXCxdbPgAFhS4&q=${uvodAdresa}`}>
                </iframe>
              </div>
            </div>

            <Features isPruh />

            <div className="zamestnanec">
              <div className="left">
                <Img className="img" alt={zamestnanecUvod} fixed={zamestnanecImg} />
                <span>{zamestnanecUvod}</span>
              </div>

              <div className="right">
                <h2>{zamestnanecH2}</h2>
                {zamestnanecDesc}
                <LinkButton text="Naše služby" to="/pohrebni-sluzba/" />
              </div>
            </div>

            <div className="sCimPomuzeme">
              <div className="top">
                <div className="left">
                  <h2>{sluzbyH2}</h2>
                  {sluzbyDesc}
                </div>

                <div className="right">
                  {isPlus900 ?
                    <Img className="obrazek" alt="Goodbye.cz" fixed={data.prochazka.childImageSharp.fixed} />
                  :
                    <Img className="obrazek" alt="Goodbye.cz" fixed={data.prochazkaSmall.childImageSharp.fixed} />
                  }
                </div>
              </div>

              <div className="bot">
                {!isLess1050 ?
                  <div className="naseSluzbyInner">

                    <div className="sluzbaBox">
                      <div className="topImg">
                        <Img className="mainImg" alt="Kremace bez obřadu" fluid={data.bezObradu.childImageSharp.fluid} />
                      </div>

                      <div className="bottom">
                        <Link className="h3Link" to="/kremace-bez-obradu/">
                          <h3>Kremace bez obřadu</h3>
                        </Link>
                        <p>Postaráme se o kremaci a urnu vám  osobně dovezeme. Samotná forma rozloučení je potom jen na vás.</p>
                        <div className="cena">
                          <span>od</span>
                          <span>12 900 Kč</span>
                        </div>
                        <div className="odrazky">
                          <h4>V ceně je zahrnuto:</h4>
                          <ul>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Sjednání za pár minut přes internet</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Vyřízení veškerých dokumentů</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Předání urny dle vašeho výběru</span>
                            </li>
                          </ul>
                        </div>
                        <Link className="cta" to="/kremace-bez-obradu/">Zjistit více</Link>
                      </div>
                    </div>

                    <div className="sluzbaBox">
                      <div className="topImg">
                        <Img className="mainImg" alt="Pohřeb s obřadem" fluid={data.sObradem.childImageSharp.fluid} />
                      </div>

                      <div className="bottom">
                        <Link className="h3Link" to="/pohreb-s-obradem/">
                          <h3>Pohřeb s obřadem</h3>
                        </Link>
                        <p>Řekněte svému blízkému sbohem při tradičním pohřbu ve smuteční síni. Celý obřad můžete přizpůsobit podle sebe.</p>
                        <div className="cena">
                          <span>od</span>
                          <span>18 990 Kč</span>
                        </div>
                        <div className="odrazky">
                          <h4>V ceně je zahrnuto:</h4>
                          <ul>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Řečník, hudba, prezentace fotek</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Vyřízení veškerých dokumentů</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>30-minutový obřad</span>
                            </li>
                          </ul>
                        </div>
                        <Link className="cta" to="/pohreb-s-obradem/">Zjistit více</Link>
                      </div>
                    </div>

                    <div className="sluzbaBox">

                      <div className="topImg">
                        <Img className="mainImg" alt="Netradiční pohřeb" fluid={data.netradicniPohreb.childImageSharp.fluid} />
                        <div className="veSpolupraci">
                          <p>Spolupracujeme s <a href="https://pohrebnipruvodci.cz">Pohřební průvodci</a></p>
                          {/* <img src={Klauni} alt="Pohřební průvodci logo" /> */}
                        </div>
                      </div>

                      <div className="bottom">

                        <Link className="h3Link" to="/netradicni-pohreb/">
                          <h3>Netradiční pohřeb</h3>
                        </Link>
                        <p>Pohřeb nemusí být jen v obřadní síni. Je spoustu jiných způsobů, jak se rozloučit. Najděte ten, který vám bude vyhovovat.</p>
                        <div className="cena">
                          <span>od</span>
                          <span>21 990 Kč</span>
                        </div>
                        <div className="odrazky">
                          <h4>V ceně je zahrnuto:</h4>
                          <ul>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Přeprava a bezobřadní kremace</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Zajištění a organizace obřadu</span>
                            </li>
                            <li>
                              <img src={Jo} alt="" />
                              <span>Rozptyl v místě vašeho výběru</span>
                            </li>
                          </ul>
                        </div>
                        <Link className="cta" to="/netradicni-pohreb/">Zjistit více</Link>
                      </div>
                    </div>

                  </div>
                  :
                  <div className="naseSluzbyInner naseSluzbyInnerSwiper">
                    <Swiper
                      slidesPerView={"auto"}
                      spaceBetween={isPlus470 ? 30 : 15}
                      navigation={true}
                      observer={true}
                      observeParents={true}
                      pagination={{ clickable: true}}
                      loop={false}
                    >
                      <SwiperSlide key={1}>
                        <div className="sluzbaBox">
                          <div className="topImg">
                            <Img className="mainImg" alt="Kremace bez obřadu" fluid={data.bezObradu.childImageSharp.fluid} />
                          </div>

                          <div className="bottom">
                            <Link className="h3Link" to="/kremace-bez-obradu/">
                              <h3>Kremace bez obřadu</h3>
                            </Link>
                            <p>Postaráme se o kremaci a urnu vám  osobně dovezeme. Samotná forma rozloučení je potom jen na vás.</p>
                            <div className="cena">
                              <span>od</span>
                              <span>12 900 Kč</span>
                            </div>
                            <div className="odrazky">
                              <h4>V ceně je zahrnuto:</h4>
                              <ul>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Sjednání za pár minut přes internet</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Vyřízení veškerých dokumentů</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Předání urny dle vašeho výběru</span>
                                </li>
                              </ul>
                            </div>
                            <Link className="cta" to="/kremace-bez-obradu/">Zjistit více</Link>
                          </div>
                        </div>
                      </SwiperSlide>

                      <SwiperSlide key={2}>
                        <div className="sluzbaBox">
                          <div className="topImg">
                            <Img className="mainImg" alt="Pohřeb s obřadem" fluid={data.sObradem.childImageSharp.fluid} />
                          </div>

                          <div className="bottom">
                            <Link className="h3Link" to="/pohreb-s-obradem/">
                              <h3>Pohřeb s obřadem</h3>
                            </Link>
                            <p>Řekněte svému blízkému sbohem při tradičním pohřbu ve smuteční síni. Celý obřad můžete přizpůsobit podle sebe.</p>
                            <div className="cena">
                              <span>od</span>
                              <span>18 990 Kč</span>
                            </div>
                            <div className="odrazky">
                              <h4>V ceně je zahrnuto:</h4>
                              <ul>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Řečník, hudba, prezentace fotek</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Vyřízení veškerých dokumentů</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>30-minutový obřad</span>
                                </li>
                              </ul>
                            </div>
                            <Link className="cta" to="/pohreb-s-obradem/">Zjistit více</Link>
                          </div>
                        </div>
                      </SwiperSlide>

                      <SwiperSlide key={3}>
                        <div className="sluzbaBox">
                          <div className="topImg">
                            <Img className="mainImg" alt="Netradiční pohřeb" fluid={data.netradicniPohreb.childImageSharp.fluid} />
                            <div className="veSpolupraci">
                              <p>Spolupracujeme s <a href="https://pohrebnipruvodci.cz">Pohřební průvodci</a></p>
                              {/* <img src={Klauni} alt="Pohřební průvodci logo" /> */}
                            </div>
                          </div>

                          <div className="bottom">
                            <Link className="h3Link" to="/netradicni-pohreb/">
                              <h3>Netradiční pohřeb</h3>
                            </Link>
                            <p>Pohřeb nemusí být jen v obřadní síni. Je spoustu jiných způsobů, jak se rozloučit. Najděte ten, který vám bude vyhovovat.</p>
                            <div className="cena">
                              <span>od</span>
                              <span>21 990 Kč</span>
                            </div>
                            <div className="odrazky">
                              <h4>V ceně je zahrnuto:</h4>
                              <ul>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Přeprava a bezobřadní kremace</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Zajištění a organizace obřadu</span>
                                </li>
                                <li>
                                  <img src={Jo} alt="" />
                                  <span>Rozptyl v místě vašeho výběru</span>
                                </li>
                              </ul>
                            </div>
                            <Link className="cta" to="/netradicni-pohreb/">Zjistit více</Link>
                          </div>
                        </div>
                      </SwiperSlide>

                    </Swiper>
                  </div>
                }
              </div>

            </div>

            <RecenzePohreb />
            
            <FAQ data={faqData}/>

          </>)}
        />
      </LokalitaInner>
    </Layout>
  );
}

export default LokalitaTemplate;
